module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Gryon_(Vaud)-e6c4efd407819219d8baeecbcfc7671e.svg";